import React from 'react'

import { ReactComponent as Client } from 'assets/icons/client.svg'

const ManagementClient: React.FC = () => {
  return (
    <div className="row panel">
      <div className="row justify-start">
        <h2><Client height="20" width="35" /> Gestão de Cliente</h2>
      </div>

      <div className="row align-end justify-start">
        <div className="form-control col-5">
          <label>Nome</label>
          <input type="text"/>
        </div>

        <div className="form-control col-5">
          <label>Email</label>
          <input type="text"/>
        </div>

        <div className="grow">
          <button
            className="button primary">
            <i className="fas fa-1x fa-search"/> Buscar
          </button>
        </div>
      </div>
    </div>
  )
}

export default ManagementClient
